export default __webpack_public_path__ + "static/media/globe.cbbbdb0a.png";